module.exports = __webpack_public_path__ + "assets/webgl/card_069_EN_L0.1de6e695.jpg";